module.exports = __webpack_public_path__ + "img/benefit-card-1-mobile.71c09b9b.png";